import React, { Component, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';

import '../../node_modules/font-awesome/scss/font-awesome.scss';

import Loader from './layout/Loader'
import Aux from "../hoc/_Aux";
import ScrollToTop from './layout/ScrollToTop';
import routes from "../route";
import { PrivateRoute } from './components/privateRoute';
import './../assets/custom_css/custom.css';
import { Ripple } from '@progress/kendo-react-ripple';
const AdminLayout = Loadable({
    loader: () => import('./layout/AdminLayout'),
    loading: Loader
});

class App extends Component {
    render() {
        const menu = routes.map((route, index) => {
          return (route.component) ? (
              <Route
                  key={index}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={props => (
                      <route.component {...props} />
                  )} />
          ) : (null);
        });

        return (
            <Aux>
                <Ripple>
                    <ScrollToTop>
                        <Suspense fallback={<Loader/>}>
                            <Switch>
                                {menu}
                                <PrivateRoute path="/" component={AdminLayout} />
                            </Switch>
                        </Suspense>
                    </ScrollToTop>
                </Ripple>
            </Aux>
        );
    }
}

export default App;
